import React from 'react';
import If from '../operator/if';

export default props => (
	<div className='box-footer'>
		{props.children}
	</div>
);
